<div class="flex-column h-100">
  <app-portal-header [displayRightMenu]="false" [displayRightLogo]="true" [displayCalendarIcon]="false"></app-portal-header>
  <div *ngIf="invalidToken || success" class="w-100 h-100 justify-content-center">
    <div *ngIf="success" class="alert alert-success page-alert justify-content-center">
      Your password has been changed. You can now <a href="login">log in</a> with your new
      password.
    </div>

    <div *ngIf="invalidToken" class="alert alert-error page-alert">
      Your password recovery request is expired. To recover your password please
      <a routerLink="/forgotPassword">repeat</a> the procedure again.
    </div>
  </div>

  <div *ngIf="!invalidToken && !success" class="flex-row w-100 h-100 justify-content-center">
    <form [formGroup]="passwordForm" [class.error]="!passwordForm.valid && passwordForm.touched"
          autocomplete="off" (ngSubmit)="submit()"
          class="flex-column form-window grey-box dense-5">

      <mat-label class="main-text-font text-sm mt-2 mb-1">
        Please enter and confirm your new password
      </mat-label>
      <mat-error *ngIf="passwordForm.hasError('passwordMismatch')">Passwords do not match</mat-error>

      <mat-form-field class="styled mb-3 email w-75" appearance="outline">
        <input matInput type="password" formControlName="newPassword" required placeholder="New password">
        <mat-error *ngIf="passwordForm.get('newPassword').hasError('required')">New Password is required</mat-error>
      </mat-form-field>

      <mat-form-field class="styled mb-3 email w-75" appearance="outline">
        <input matInput type="password" formControlName="confirmPassword" required placeholder="Confirm password">
        <mat-error *ngIf="passwordForm.get('confirmPassword').hasError('required')">Confirm Password is required</mat-error>
      </mat-form-field>

      <div class="mt-1">
        <button mat-stroked-button class="styled primary me-1" [disabled]="loading || !passwordForm.valid">Submit
        </button>
        <button mat-stroked-button class="styled secondary" routerLink="/"
                [disabled]="loading">Cancel
        </button>
      </div>
    </form>
  </div>
  <app-main-footer></app-main-footer>
</div>
